/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.27/esri/copyright.txt for details.
*/
const b="20230626",a="b81703b48e0b92e492f4cc6b739af02a9af50038";export{b as buildDate,a as commitHash};
